import { Dialog } from "@headlessui/react";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { useForm } from "react-hook-form";
import { UserListSearch } from "./UserListSearch";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { SetStateAction } from "react";
import { SearchUserList, UserData } from "../../model/Users";
import { Company } from "../../model/Companies";
import { CheckBoxItem } from "../../components/checkBox/CheckBoxGroup";
import { Spiner } from "../../components/spinner/Spiner";

export type TargetUserSelectedModalProps = {
  onClickSelect: (data: any) => Promise<void>;
  setSelectGroup: (value: SetStateAction<{id:string, title:string}[]>) => void;
  selectGroup: {id:string, title:string}[];
  setUserListResult: (value: SetStateAction<SearchUserList>) => void;
  userListResult: SearchUserList;
  onSelectCancel?: () => void;
  firstPageFlg?: boolean;
  setFirstPageFlg?: Function;
  cols: GridCol[];
  rows: GridRow[];
  userList: UserData[] | undefined;
  company: Company | undefined;
  setSearchUserList: Function;
  setSearchUserListFlg: Function;
  setGroupsValue: (value: SetStateAction<CheckBoxItem[]>) => void;
  groupsValue: CheckBoxItem[];
  defaultGroups: CheckBoxItem[];
  onSearch: (searchCondition: any) => void;
  searchCondition: any;
  pagingFunc?: (ver: number) => void;
  totalCount?: number;
  isLode?: boolean;
};

export const TargetUserSelectedModal = ({
  open,
  toggle,
  closeOnClickOutside,
  onClickSelect,
  setSelectGroup,
  selectGroup,
  setUserListResult,
  userListResult,
  onSelectCancel,
  firstPageFlg = false,
  setFirstPageFlg,
  cols,
  rows,
  userList,
  company,
  setSearchUserList,
  setSearchUserListFlg,
  setGroupsValue,
  groupsValue,
  defaultGroups,
  onSearch,
  searchCondition,
  pagingFunc,
  totalCount,
  isLode = false,
}: ModalProp & TargetUserSelectedModalProps) => {

  const { handleSubmit } =
      useForm<any>({
        defaultValues: [],
      });

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all w-[calc(100vw_-_10rem)]">
          <div className="px-2 pb-2 sm:p-4">
            <div className="mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900"
              >
                対象者選択
              </Dialog.Title>
              <div className="overflow-y-auto px-8 text-left pb-8 h-fit max-h-[calc(100vh_-_10rem)]">
                <div className="min-w-fit">
                  <div className={"pt-6 pb-3"}>
                    <UserListSearch
                      setSelectGroup={setSelectGroup}
                      selectGroup={selectGroup}
                      setUserListResult={setUserListResult}
                      userListResult={userListResult}
                      userList={userList}
                      company={company}
                      setSearchUserListFlg={setSearchUserListFlg}
                      setSearchUserList={setSearchUserList}
                      setGroupsValue={setGroupsValue}
                      groupsValue={groupsValue}
                      defaultGroups={defaultGroups}
                      onSearch={onSearch}
                      searchCondition={searchCondition}
                    />
                  </div>
                  <div>
                    {isLode ? (
                      <Spiner />
                    ) : (
                      <TableList 
                        header 
                        gridCol={cols} 
                        gridRow={rows}
                        firstPageFlg={firstPageFlg}
                        setFirstPageFlg={setFirstPageFlg}
                        pagingFunc={pagingFunc}
                        gridRowLength={totalCount}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={onSelectCancel}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 w-[132px]"
              onClick={handleSubmit(onClickSelect)}
              children={"選択"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  );
};
